import { z } from 'zod';

export const EventCategoryValues = [
  'ARTISTIC_CULTURAL',
  'EDUCATIONAL_PRO',
  'SPORTS',
  'ASSOCIATIVE',
] as const;

export type EventCategoryType = (typeof EventCategoryValues)[number];

export const EventCategorySchema = z.enum(EventCategoryValues);

export const CreateEventSchema = z.object({
  title: z.string().min(3, 'Title must be at least 3 characters').max(200),
  description: z.string().max(3000).optional().nullable(),
  imageUrl: z.string().max(512).optional().nullable(),
  category: EventCategorySchema.optional().nullable(),
  startDateTime: z.coerce.date().optional().nullable(),
  endDateTime: z.coerce.date().optional().nullable(),
  expiryDate: z.coerce.date().optional().nullable(),
});

export const UpdateEventSchema = z.object({
  title: z.string().min(3).max(200).optional(),
  description: z.string().max(3000).optional().nullable(),
  imageUrl: z.string().max(512).optional().nullable(),
  category: EventCategorySchema.optional().nullable(),
  startDateTime: z.coerce.date().optional().nullable(),
  endDateTime: z.coerce.date().optional().nullable(),
  expiryDate: z.coerce.date().optional().nullable(),
  status: z.enum(['COMING_SOON', 'SCHEDULED', 'ARCHIVED']).optional(),
});

export const SetEventDateSchema = z.object({
  startDateTime: z.coerce.date(),
  endDateTime: z.coerce.date().optional().nullable(),
  expiryDate: z.coerce.date().optional().nullable(),
});

export const EventFilterSchema = z.object({
  from: z.coerce.date().optional(),
  to: z.coerce.date().optional(),
  status: z.enum(['COMING_SOON', 'SCHEDULED', 'ARCHIVED']).optional(),
  category: EventCategorySchema.optional().nullable(),
  scope: z.enum(['all', 'mine']).default('all'),
  search: z.string().max(100).optional(),
});

/** `GET /events/me/calendar`: oubay's optional `from` and `to`. */
export const EventCalendarQuerySchema = z.object({
  from: z.coerce.date().optional(),
  to: z.coerce.date().optional(),
});
